import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import find from "lodash/find";
import { createSelector } from "reselect";
import { validateIccIdSelector } from "./validateIccId";

export const eligiblePlansDomain = state =>
  get(state, "api.eligiblePlans.data", {});

// ***************************************************************
// ******************** eligiblePlans selectors ********************
// ***************************************************************
export const eligiblePlansSelector = createSelector(
  eligiblePlansDomain,
  validateIccIdSelector,
  (eligiblePlans, iccIdDetails) => {
    const iccIdPlanName = get(iccIdDetails, "plan.name");
    const iccIdPlan = find(eligiblePlans, { name: iccIdPlanName });
    // treat only sim plan as eligible it is valid
    if (!isEmpty(iccIdPlan)) return [iccIdPlan];
    return eligiblePlans;
  }
);
// ***************************************************************
// ******************* eligiblePlans makeSelect ********************
// ***************************************************************

export const makeSelectEligiblePlans = () => eligiblePlansSelector;
